module.exports = __webpack_public_path__ + "static/media/app-store-new.19b09536.png";